import { useEffect } from "react";

const SITE = "https://lifeisaproject.global";

/**
 * useSeo — per-page title, meta description, canonical URL and Open Graph
 * tags for CMS detail pages. Previous values are restored on unmount so
 * the static site metadata remains intact elsewhere.
 */
export default function useSeo(seo) {
    const { title, description, path, image } = seo || {};

    useEffect(() => {
        if (!title) return undefined;
        const prevTitle = document.title;
        document.title = title;

        const managed = [];
        const upsert = (selector, tag, attr, attrValue, content) => {
            let el = document.head.querySelector(selector);
            const existed = !!el;
            if (!el) {
                el = document.createElement(tag);
                el.setAttribute(attr, attrValue);
                document.head.appendChild(el);
            }
            managed.push({ el, existed, prev: existed ? (el.getAttribute("content") || el.getAttribute("href")) : null });
            if (tag === "link") el.setAttribute("href", content);
            else el.setAttribute("content", content);
        };

        if (description) {
            upsert('meta[name="description"]', "meta", "name", "description", description);
            upsert('meta[property="og:description"]', "meta", "property", "og:description", description);
        }
        upsert('meta[property="og:title"]', "meta", "property", "og:title", title);
        upsert('meta[property="og:type"]', "meta", "property", "og:type", "article");
        if (path) {
            upsert('meta[property="og:url"]', "meta", "property", "og:url", `${SITE}${path}`);
            upsert('link[rel="canonical"]', "link", "rel", "canonical", `${SITE}${path}`);
        }
        if (image) upsert('meta[property="og:image"]', "meta", "property", "og:image", image);

        return () => {
            document.title = prevTitle;
            managed.forEach(({ el, existed, prev }) => {
                if (existed) {
                    if (el.tagName === "LINK") el.setAttribute("href", prev || "");
                    else el.setAttribute("content", prev || "");
                } else if (el.parentNode) {
                    el.parentNode.removeChild(el);
                }
            });
        };
    }, [title, description, path, image]);
}
